export default __webpack_public_path__ + "src/assets/images/icon-groups.png";